var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pc-bread-crumb", { attrs: { data: _vm.articleData.breadcrumbs } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wf-hero-banner" },
        [
          _c("pc-responsive-image", {
            attrs: {
              desktopSrc: _vm.articleData.desktopSrc.replace("~", ""),
              mobileSrc: _vm.articleData.mobileSrc.replace("~", ""),
              imageAlt: _vm.articleData.alt,
              imageCss: "background-image"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pc-backand-share-button")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }